<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">调用接口</h1>
		<h2 class="doc_main_h2">识别一个Bitmap图像</h2>
		<h3 class="doc_main_h3">1.直接调用</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKEyeSDK_Image(String service_name, 
Bitmap bitmap) throws IOException, JSONException, KeyManagementException, NoSuchAlgorithmException;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）service_name：识别服务名称</p>
        <p class="doc_main_p">（2）bitmap：Bitmap图片</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKEyeSDK_Image(String service_name, 
	Bitmap bitmap, final ImageCallback imageCallback) throws IOException, JSONException, 
	KeyManagementException, NoSuchAlgorithmException;

public void SKEyeSDK_Image(String image_id, String service_name, Bitmap bitmap, final 
	ImageCallbackimageCallback) throws IOException, 
	JSONException, KeyManagementException, NoSuchAlgorithmException;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）image_id：图片id（方便确认请求顺序和返回顺序是否一致）</p>
        <p class="doc_main_p">（2）service_name：识别服务名称</p>
        <p class="doc_main_p">（3）bitmap：Bitmap图片</p>
        <p class="doc_main_p">（4）imageCallback：回调接口</p>
        <h4 class="doc_main_h4">接口回调返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 直接调用
String result = skEyeSDK.SKEyeSDK_Image(
service_name, bmp);
// 接口回调
skEyeSDK.SKEyeSDK_Image(
service_name, bmp, new ImageCallback() {
	@Override
	public void recognitionInfo(String result) {
	    // 在这里可以对识别结果result进行处理
	}
});
skEyeSDK.SKEyeSDK_Image(image_id, service_name, bmp,
 new ImageCallback() {
	@Override
	public void recognitionInfo(String result) {
	    // 在这里可以对识别结果result进行处理
	}
});</code></pre>


        <h2 class="doc_main_h2">识别一个url（网络url、本地路径）图像</h2>
        <h3 class="doc_main_h3">1.直接调用</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKEyeSDK_Image(String service_name, 
String image_url)throws IOException, JSONException, KeyManagementException, NoSuchAlgorithmException;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）service_name：识别服务名称</p>
        <p class="doc_main_p">（2）imageUrl：图像的url（网络url或者本地路径）</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>

        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKEyeSDK_Image(String service_name, 
	String image_url, final ImageCallback imageCallback) throws IOException, JSONException,
	KeyManagementException;

public void SKEyeSDK_Image(String image_id, String service_name, String image_url, 
	final ImageCallback imageCallback) throws IOException, JSONException,
	KeyManagementException;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）image_id：图片id（方便确认请求顺序和返回顺序是否一致）</p>
        <p class="doc_main_p">（2）service_name：识别服务名称</p>
        <p class="doc_main_p">（3）imageUrl：图像的url（网络url或者本地路径）</p>
        <p class="doc_main_p">（4）imageCallback：回调接口</p>
        <h4 class="doc_main_h4">接口回调返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 直接调用
String result = skEyeSDK.SKEyeSDK_Image(
service_name, image_url);
// 接口回调
skEyeSDK.SKEyeSDK_Image(service_name,
image_url, new ImageCallback() {
	@Override
	public void recognitionInfo(String result) {
		// 在这里可以对识别结果result进行处理
	}
});
skEyeSDK.SKEyeSDK_Image(image_id, service_name,
image_url, new ImageCallback() {
	@Override
	public void recognitionInfo(String result) {
		// 在这里可以对识别结果result进行处理
	}
});</code></pre>

		<h2 class="doc_main_h2">识别一个YUV数据格式图像</h2>
		<h3 class="doc_main_h3">1.直接调用</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKEyeSDK_Image(String service_name, 
		byte[] image_YUVData,int image_width, 
int image_height) throws IOException, JSONException,
		KeyManagementException, NoSuchAlgorithmException;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）service_name：识别服务名称</p>
        <p class="doc_main_p">（2）imageYUVData：图像的YUV数据byte数组</p>
        <p class="doc_main_p">（3）imageWidth：图像宽度</p>
        <p class="doc_main_p">（4）imageHeight：图像高度</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKEyeSDK_Image(String service_name, 
byte[] image_YUVData,int image_width, 
int image_height, final ImageCallback imageCallback)
throws IOException, JSONException, 
KeyManagementException, NoSuchAlgorithmException;

public void SKEyeSDK_Image(String image_id, String service_name, byte[] image_YUVData,int image_width, 
int image_height, final ImageCallback imageCallback)
throws IOException, JSONException, 
KeyManagementException, NoSuchAlgorithmException;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）image_id：图片id（方便确认请求顺序和返回顺序是否一致）</p>
        <p class="doc_main_p">（2）service_name：识别服务名称</p>
        <p class="doc_main_p">（3）imageYUVData：图像的YUV数据byte数组</p>
        <p class="doc_main_p">（4）imageWidth：图像宽度</p>
        <p class="doc_main_p">（5）imageHeight：图像高度</p>
        <p class="doc_main_p">（6）imageCallback：回调接口</p>
        <h4 class="doc_main_h4">接口回调返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 直接调用
String result = skEyeSDK.SKEyeSDK_Image(
service_name, imageYUVData, bmpW, bmpH);
// 接口回调
skEyeSDK.SKEyeSDK_Image(service_name, image_YUVData, 
image_width, image_height, new ImageCallback() {
	@Override
	public void recognitionInfo(String result) {
		// 在这里可以对识别结果result进行处理
	}
});
skEyeSDK.SKEyeSDK_Image(image_id, service_name, image_YUVData, image_width, image_height, 
new ImageCallback() {
	@Override
	public void recognitionInfo(String result) {
		// 在这里可以对识别结果result进行处理
	}
});</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import SKEyeJson from '../../../components/SKEyeJson'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'sk-eye-json':SKEyeJson,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Android','调用接口'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeandroid/callImageInterface.vue